<template>
  <div class="demo-page">
      <MFlowEditor ref="editor" :left-panel-visible="true" :right-panel-visible="false" :bottom-panel-visible="true" />

  </div>
</template>

<script setup lang="ts">
import { 
  MFlowEditor, 
  setupMFlow
} from 'mflows'
import { ref, onMounted } from 'vue'
import { useWorkflowStore } from 'mflows'

// 使用预定义配置简化节点注册
setupMFlow()

const editor = ref<InstanceType<typeof MFlowEditor> | null>(null)
import 'mflows/style.css'

const workflow = useWorkflowStore()

onMounted(()=>{
  // if(editor.value){
  //    console.log(editor.value,'editor');
  // }

  // // 首次进入时自动加载综合 Demo（IfElse + ForEach）。若加载失败，则回退到最小可运行示例
  // if (workflow.state.nodes.length === 0) {
  //   fetch('/snippets/ifelse_foreach_demo.json')
  //     .then(res => res.json())
  //     .then(data => {
  //       try {
  //         workflow.importWorkflow(data.nodes || [], data.edges || [])
  //       } catch (e) {
  //         console.warn('加载综合 Demo 失败，回退到最小示例:', e)
  //         fallbackInit()
  //       }
  //     })
  //     .catch(() => fallbackInit())
  // }

  // function fallbackInit(){
  //   // 最小示例：InitialNode -> ArrayInput -> ForEach(item/done) -> Debug
  //   const nodes = [
  //     {
  //       id: 'n_init',
  //       type: 'InitialNode',
  //       label: '开始',
  //       position: { x: 120, y: 80 },
  //       data: { componentType: null, parentData: {}, config: { autoTrigger: true } }
  //     },
  //     {
  //       id: 'n_arr',
  //       type: 'ArrayInput',
  //       label: '数组',
  //       position: { x: 120, y: 240 },
  //       data: { componentType: null, parentData: {}, config: { value: [1,2,3] } }
  //     },
  //     {
  //       id: 'n_each',
  //       type: 'ForEach',
  //       label: '遍历',
  //       position: { x: 420, y: 240 },
  //       data: { componentType: null, parentData: {}, config: {} }
  //     },
  //     {
  //       id: 'n_dbg_item',
  //       type: 'DebugNode',
  //       label: '调试(item)',
  //       position: { x: 740, y: 200 },
  //       data: { componentType: null, parentData: {}, config: {} }
  //     },
  //     {
  //       id: 'n_dbg_done',
  //       type: 'DebugNode',
  //       label: '调试(done)',
  //       position: { x: 740, y: 280 },
  //       data: { componentType: null, parentData: {}, config: {} }
  //     }
  //   ] as any

  //   const edges = [
  //     { id: 'e_init_each', source: 'n_init', sourceHandle: 'initial-exec', target: 'n_each', targetHandle: 'execute' },
  //     { id: 'e_arr_each', source: 'n_arr', sourceHandle: 'array-data', target: 'n_each', targetHandle: 'list' },
  //     { id: 'e_each_item_dbg', source: 'n_each', sourceHandle: 'item', target: 'n_dbg_item', targetHandle: 'input' },
  //     { id: 'e_each_done_dbg', source: 'n_each', sourceHandle: 'done', target: 'n_dbg_done', targetHandle: 'input' }
  //   ] as any

  //   workflow.importWorkflow(nodes as any, edges as any)
  // }
})

</script>

<style scoped>
.demo-page {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #121212;
  color: #ddd;
}
</style>
